import React, { useState } from 'react'
import {
  Col,
  Row
} from 'reactstrap'

import CardContextDynamic from '../../../components/Common/CardContextDynamic'
import CardFlowDynamic from '../../../components/Common/CardFlowDynamic'
import { useSelector } from 'react-redux'

export default function GridHeader({ context }) {
  const {
    isLoading,
    gridComponents,
  } = React.useContext(context)

  const isModalPage = useSelector(state => state.Layout.isModalPage)
  
  const headerComponentsRender = gridComponents.HEADER[0]?.Childrens
  
  const contextBlock = headerComponentsRender?.find(
    item => item.Chave_Transacao_Componente === 'CONTEXTO_001'
  )
  
  const flowBlock = headerComponentsRender?.find(
    item => item.Chave_Transacao_Componente === 'FLUXO_001'
  )

  return (
    <>
      <Row className="p-2">
        <Col
          lg={12}
          className={`mb-1 nav-accordion-custom ${isLoading ? 'disabled' : ''}`}
        >
          
          <div className="mb-1">
            <div className='row'>
              {flowBlock?.Childrens && (                  
                  <div className={"col-12 mb-3"}>
                    <CardFlowDynamic dataTree={flowBlock?.Childrens} />
                  </div>
                )}
              {contextBlock && (
                <div className="col-12">
                  <CardContextDynamic contextBlock={contextBlock?.Childrens} isRenderModal={isModalPage} />
                </div>
              )}
            </div>
          </div>
        </Col>
      </Row>
    </>
  )
}
